import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

import FrontPage from './components/frontpage/frontpage';
import Services from './components/services/services';
import Products from './components/products/products';
import Contact from './components/contact/contact';
import Aboutme from './components/aboutme/aboutme';
import Sidebar from './Sidebar';
import PC_app from './components/services/pc_app';
import Web_app from './components/services/web_app';

import Login from './components/loginarea/login';
import EmailView from './components/loginarea/emailview';
import PrivacyPolicy from './components/dataprotection/privacypolicy';
import  DeleteAccount from './components/dataprotection/deleteaccount';
function App() {
  return (
    <BrowserRouter>
      <div className="App">
        {/* Sidebar hier einfügen */}
        <div className="content">
       
          <Routes>
            <Route path="/" element={<FrontPage />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/application-software" element={<PC_app />} />
            <Route path="/services/web-development" element={<Web_app />} />

            <Route path="/products" element={<Products />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<Aboutme/>} />
             <Route path="/privacy-policy/drunkmaster" element={<PrivacyPolicy/>} />
              <Route path="/privacy-policy/dontask" element={<PrivacyPolicy/>} />
               <Route path="/privacy-policy/cosmictap" element={<PrivacyPolicy/>} />
               <Route path="/privacy-policy/vulpio" element={<PrivacyPolicy/>} />
                <Route path="/delete-account/vulpio" element={<DeleteAccount/>} />
            {/* Weitere Routen hier hinzufügen */}
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;